import React from 'react';
import { useTranslation } from 'react-i18next';
// import { Table } from 'antd';
// import JSONInput from 'react-json-editor-ajrm';
// import locale from 'react-json-editor-ajrm/locale/en';
import { formatTime } from '../../../../utils';
import styles from './index.module.scss';

interface ParamProps {
  id: number,
  apiId: number,
  paramName: string,
  required: boolean,
  paramWhere: number,
  paramType?: string,
  note?: string,
  valueDesc?: string,
  paramTag?: number,
  [x: string]: any
}

type Props = {
  provider?: string,
  createTime?: number
}

// const columns = [
//   {
//     title: 'Name',
//     dataIndex: 'paramName',
//     key: 'paramName',
//     width: 180,
//     render: (text: string) => <span>{text}</span>,
//   },
//   {
//     title: 'Required',
//     dataIndex: 'required',
//     key: 'required',
//     width: 180,
//     render: (text: boolean) => text.toString(),
//   },
//   {
//     title: 'Type',
//     dataIndex: 'paramType',
//     width: 180,
//     key: 'paramType',
//   },
//   {
//     title: 'Example',
//     dataIndex: 'note',
//     width: 180,
//     key: 'note',
//   },
//   {
//     title: 'Description',
//     dataIndex: 'valueDesc',
//     key: 'valueDesc',
//   },
// ];
const dataSource: Array<ParamProps> = [
  {
    id: 18,
    apiId: 2002,
    paramName: 'mobiles',
    required: true,
    paramWhere: 2,
    paramType: '',
    note: '15995479082',
    valueDesc: '手机号',
    paramTag: 0,
  },
  {
    id: 19,
    apiId: 2002,
    paramName: 'content',
    required: true,
    paramWhere: 2,
    paramType: '',
    note: '【分布科技】您的验证码是：826425',
    valueDesc: '短信内容，格式：【企业】短信内容',
    paramTag: 0,
  },
  {
    id: 20,
    apiId: 2002,
    paramName: 'timerTime',
    required: false,
    paramWhere: 2,
    paramType: '',
    note: '',
    valueDesc: '定时发送时间(选填，定时时间90天以内)，格式：yyyyMMddHHmmSS,如果不填为即时发送',
    paramTag: 0,
  },
  {
    id: 21,
    apiId: 2002,
    paramName: 'customSmsId',
    required: false,
    paramWhere: 2,
    paramType: '',
    note: '',
    valueDesc: '自定义消息ID(选填),最长64位',
    paramTag: 0,
  },
  {
    id: 22,
    apiId: 2002,
    paramName: 'extendedCode',
    required: false,
    paramWhere: 2,
    paramType: '',
    note: '',
    valueDesc: '扩展码, 最长12位，如最终号码长度超长，会截取扩展码',
    paramTag: 0,
  },
];

const APIInfoLay: React.FC<Props> = ({ provider, createTime }) => {
  const { t } = useTranslation();
  // eslint-disable-next-line no-return-assign
  dataSource.map(ele => ele.key = ele.id);
  return (
    <ul className={styles.apiBaseInfo}>
      <li>
        <div className={styles.labelName}>{`API ${t('address')}`}</div>
        <div className={styles.labelInfo}>{provider}</div>
      </li>
      <li>
        <div className={styles.labelName}>{t('request_methods')}</div>
        <div className={styles.labelInfo}>POST</div>
      </li>
      <li>
        <div className={styles.labelName}>{t('create_time')}</div>
        <div className={styles.labelInfo}>{formatTime(createTime)}</div>
      </li>
      {/* <li> */}
      {/*  <div className={styles.labelName}>RESPONSE EXAMPLE</div> */}
      {/*  <div className={styles.labelInfo}> */}
      {/*    <JSONInput */}
      {/*      id="a_unique_id" */}
      {/*      placeholder={{ */}
      {/*        "requestParams": [ */}
      {/*          { */}
      {/*            "id": 18, */}
      {/*            "apiId": 2002, */}
      {/*            "paramName": "mobiles", */}
      {/*            "required": true, */}
      {/*            "paramWhere": 2, */}
      {/*            "paramType": "", */}
      {/*            "note": "15995479082", */}
      {/*            "valueDesc": "手机号", */}
      {/*            "paramTag": 0 */}
      {/*          }, */}
      {/*          { */}
      {/*            "id": 19, */}
      {/*            "apiId": 2002, */}
      {/*            "paramName": "content", */}
      {/*            "required": true, */}
      {/*            "paramWhere": 2, */}
      {/*            "paramType": "", */}
      {/*            "note": "【分布科技】您的验证码是：826425", */}
      {/*            "valueDesc": "短信内容，格式：【企业】短信内容", */}
      {/*            "paramTag": 0 */}
      {/*          }, */}
      {/*          { */}
      {/*            "id": 20, */}
      {/*            "apiId": 2002, */}
      {/*            "paramName": "timerTime", */}
      {/*            "required": false, */}
      {/*            "paramWhere": 2, */}
      {/*            "paramType": "", */}
      {/*            "note": "", */}
      {/*            "valueDesc": "定时发送时间(选填，定时时间90天以内)，格式：yyyyMMddHHmmSS,如果不填为即时发送", */}
      {/*            "paramTag": 0 */}
      {/*          } */}
      {/*        ] */}
      {/*      }} */}
      {/*      locale={locale} */}
      {/*      height="350px" */}
      {/*      width="100%" */}
      {/*      viewOnly={true} */}
      {/*    /> */}
      {/*  </div> */}
      {/* </li> */}
      {/* <li> */}
      {/*  <div className={styles.labelName}>REQUEST PARAMETER DESCRIPTION</div> */}
      {/*  <div className={styles.labelInfo}> */}
      {/*    <div className="g-table-wrapper"> */}
      {/*      <Table columns={columns} dataSource={dataSource} pagination={false} /> */}
      {/*    </div> */}
      {/*  </div> */}
      {/* </li> */}

    </ul>
  );
};

export default APIInfoLay;
